import URL from 'url';
import { connect } from 'react-redux';
import {
    PROVIDER_URL_PREFIX,
    PROFESSIONAL_URL_PREFIX,
} from '@zocdoc-frontend-common/components-sign-in-form/constants';
import {
    LOGIN_STATE,
    USER_TYPE,
} from '@zocdoc-frontend-common/state-user-account/constants';
import { BASE_PATH } from 'src/accounts/signin/constants';
import {
    useAppleSsoOnSignInPage,
    useFacebookSsoOnSignInPage,
    useGoogleSsoOnSignInPage,
} from '../../../../config/ab/selector';
import {
    LOCATION_REDUCER_KEY,
    USER_REDUCER_KEY,
    SIGN_IN_REDUCER_KEY,
} from '../../../redux/reducers';
import SignIn from './SignIn';

const mapStateToProps = (state) => {
    const location = state[LOCATION_REDUCER_KEY];
    const signInForm = state[SIGN_IN_REDUCER_KEY];
    const user = state[USER_REDUCER_KEY];
    const parsedUrl = URL.parse(location.href, true);
    const urlQueryParams = parsedUrl.query;
    const signedIn =
        user?.login_state === LOGIN_STATE.LoggedIn || signInForm.signedIn;
    const isPatient = user?.user_type === USER_TYPE.Patient;

    let returnUrl;
    Object.keys(urlQueryParams).forEach((param) => {
        if (param.toLowerCase() === 'returnurl') {
            returnUrl = urlQueryParams[param];
        }
    });

    if (
        (returnUrl?.includes(PROVIDER_URL_PREFIX) ||
            returnUrl?.includes(PROFESSIONAL_URL_PREFIX)) &&
        isPatient
    ) {
        returnUrl = null;
    }

    if (returnUrl?.startsWith(BASE_PATH)) {
        returnUrl = null;
    }

    const hasRLoginQueryParam =
        Object.keys(urlQueryParams).filter(
            (k) => k.toLowerCase() === 'rlogin' && urlQueryParams[k] === 'true'
        ).length > 0;
    const hasProviderQueryParam =
        Object.keys(urlQueryParams).filter(
            (k) => k.toLowerCase() === 'provider' && urlQueryParams[k] === '1'
        ).length > 0;
    const showProviderMode =
        hasProviderQueryParam ||
        hasRLoginQueryParam ||
        returnUrl?.startsWith(PROVIDER_URL_PREFIX) ||
        returnUrl?.startsWith(PROFESSIONAL_URL_PREFIX);

    return {
        signedIn,
        responseBody: signInForm.responseBody,
        location,
        showProviderMode,
        showFacebookLoginButton: useFacebookSsoOnSignInPage(state),
        showGoogleLoginButton: useGoogleSsoOnSignInPage(state),
        showAppleLoginButton: useAppleSsoOnSignInPage(state),
        showRememberMe: true,
        rememberMe: true,
        socialLoginValidationError: parseInt(
            urlQueryParams.socialLoginValidationError,
            10
        ),
        suggestedRedirect: signInForm.suggestedRedirect,
        returnUrl,
    };
};

export default connect(mapStateToProps)(SignIn);
